import { render, staticRenderFns } from "./chateau-cantenac-brown.vue?vue&type=template&id=5c0e2434&scoped=true"
import script from "./chateau-cantenac-brown.vue?vue&type=script&lang=js"
export * from "./chateau-cantenac-brown.vue?vue&type=script&lang=js"
import style0 from "./chateau-cantenac-brown.vue?vue&type=style&index=0&id=5c0e2434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0e2434",
  null
  
)

export default component.exports